module.exports = __webpack_public_path__ + "img/postImage.09673249.png";